export type PhoneNumbersResponseBody = {
  code: string;
  name: string;
  prefix: string;
  preferred: boolean;
};
export type GetPhoneNumbersApiResponse = /** status 200  */ PhoneNumbersResponseBody[];
export type GetPhoneNumbersApiArg = void;
